export function toBase64(data: any): string {
  const json = JSON.stringify(data);
  const encoded = new TextEncoder().encode(json);
  const binary = Array.from(encoded, (byte) => String.fromCharCode(byte)).join(
    "",
  );
  return btoa(binary);
}
